/**
 * useWithdrawHistories Hook
 * 본사 입출금 내역 조회 전용 훅
 */
import { useCallback, useState } from 'react';
import { headWithdrawApi } from '../api/headWithdrawApi';
import {
    HeadWithdrawHistory,
    headWithdrawHistoryListFromDto,
    UseHeadWithdrawDataParams
} from '../types/headWithdraw.types';
import { ToastType } from '@/shared/components/feedback/Toast/Toast.types';
import { useToast } from '@/shared/components/feedback/Toast/ToastContext';

export const useWithdrawHistories = (params?: UseHeadWithdrawDataParams) => {
    const { showToast } = useToast();
    const [loading, setLoading] = useState(false);
    const [histories, setHistories] = useState<HeadWithdrawHistory[]>([]);
    const [currentBalanceByRider, setCurrentBalanceByRider] = useState<Record<string, number>>({});
    const [currentBalanceBySupplier, setCurrentBalanceBySupplier] = useState<Record<string, number>>({});

    const fetchHistories = useCallback(async (
        fromDate: string,
        toDate: string,
        wdType?: string,
        reqType?: string,
        supplierId?: string,
        supplierName?: string,
        riderId?: string,
        riderName?: string,
        suppType?: string,
    ) => {
        try {
            setLoading(true);
            const targetSupplierId = supplierId || params?.supplierId;

            const response = await headWithdrawApi.getHeadWithdrawHistoryList(
                fromDate,
                toDate,
                wdType,
                reqType,
                targetSupplierId,
                supplierName,
                riderId,
                riderName,
                suppType
            );

            if (response) {
                const historyList = headWithdrawHistoryListFromDto(response);
                setHistories(historyList || []);
                setCurrentBalanceByRider(response.currentBalanceByRider || {});
                setCurrentBalanceBySupplier(response.currentBalanceBySupplier || {});
            } else {
                setHistories([]);
                setCurrentBalanceByRider({});
                setCurrentBalanceBySupplier({});
            }
        } catch (error: unknown) {
            if (error && typeof error === 'object' && 'response' in error) {
                const axiosError = error as { response?: { status?: number } };
                if (axiosError.response?.status !== 404) {
                    showToast('입출금내역을 불러오는데 실패했습니다.', { type: ToastType.ERROR });
                }
            } else {
                showToast('입출금내역을 불러오는데 실패했습니다.', { type: ToastType.ERROR });
            }
            setHistories([]);
        } finally {
            setLoading(false);
        }
    }, [params?.supplierId, showToast]);

    return {
        loading,
        histories,
        currentBalanceByRider,
        currentBalanceBySupplier,
        fetchHistories,
    };
};
